import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { postAbortAudio } from '../../services/AudioAnnouncementService';
import type { AbortAudioRequest, AbortAudioResponse } from '../../types/AudioAnnouncement';

type Result = UseMutationResult<AbortAudioResponse, Error, AbortAudioRequest>;

function useAbortAudio(
  successCb: (res: AbortAudioResponse) => void,
  failureCb: (error: string) => void,
): Result {
  const queryClient = useQueryClient();

  return useMutation(postAbortAudio, {
    onSuccess: (data, variables) => {
      successCb(data);
      queryClient.invalidateQueries({
        queryKey: ['audio-announcement-devices', variables.fleetId, variables.audioId],
      });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useAbortAudio;
